export default function ImageBackgroundSlide({ imageSrc, alt, children, className }) {
    return (
        <div className='relative w-full h-full'>
            <img src={imageSrc} alt={alt} className='absolute inset-0 object-cover w-full h-full' />
            <div className={`relative z-10 h-full w-full bg-black/40 ${className}`}>{children}</div>
        </div>
    )
}
